import { SelectOption } from '@missionlabs/react'
import { WhatsAppBusinessTemplate } from '@missionlabs/types'
import { useMemo } from 'react'
import { useGetWhatsAppTemplatesQuery } from 'shared/store'

import { Features } from './useHasClientFeature'
import { useHasFeature } from './useHasFeature'

// Stable references so consumers' memos/effects don't re-run while there is no data
const NO_TEMPLATES: WhatsAppBusinessTemplate[] = []

export const useWhatsAppTemplates = () => {
    const isWhatsAppEnabled = useHasFeature(Features.whatsapp)

    const { data: templates = NO_TEMPLATES, isLoading } = useGetWhatsAppTemplatesQuery(undefined, {
        skip: !isWhatsAppEnabled
    })

    const templateOptions: SelectOption[] = useMemo(
        () => templates.map(template => ({ label: template.name, value: template.name })),
        [templates]
    )

    return { templates, templateOptions, isLoading }
}
